import { call, put, takeLatest } from 'redux-saga/effects';
import { Creators, Types } from '../../redux/map/actions';
import {
  fetchGeojsonData as fetchGeojsonDataApi,
} from '../../api/map';
import _ from 'lodash';

export function* fetchGeojsonData(actions) {
  try {
    const response = yield call(fetchGeojsonDataApi);
    let responseData = response.data;
    if (responseData) {
      yield put(Creators.fetchGeojsonDataSuccess( JSON.parse(JSON.stringify(responseData)) ));
    }
  } catch (error) {
    let error_message = _.get(error, 'response.data.errors')
    yield put(Creators.fetchGeojsonDataFailure(error_message));
  }
}

export function* watchFetchGeojsonData() {
  yield takeLatest(Types.FETCH_GEOJSON_DATA, fetchGeojsonData);
}
